export default __webpack_public_path__ + "static/media/image.62cbcd95.png";